const titlesFor = (locale) => {
  const isZh = locale === 'zh'
  return {
    basboard: isZh ? '战篮' : 'Basboard',
    traincord: isZh ? '练志' : 'TrainCord',
    statpoint: isZh ? '赛点' : 'StatPoint'
  }
}
// The tab title follows the persisted/toggled locale rather than navigator.language.
export function applyPageTitle(route, locale) {
  const titles = titlesFor(locale)
  if (route.path === '/') {
    document.title = titles.basboard
    return
  }
  let title = titles.basboard
  if (route.path.includes('traincord')) title = titles.traincord
  else if (route.path.includes('statpoint')) title = titles.statpoint
  document.title = (route.meta && route.meta.title) || title
}
